//@flow
import * as Immutable from 'immutable';

import { RescheduleInfo } from 'models/flow/RescheduleInfo.js';
import type { RescheduleInfoModelType } from 'models/flow/RescheduleInfo.js';

class InternalRescheduleInfo extends RescheduleInfo {
    static fromJS(json: RescheduleInfoModelType): InternalRescheduleInfo {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export { InternalRescheduleInfo as RescheduleInfo };
